import React, { useEffect, useState } from "react";
import { Grid, TextField, MenuItem, Checkbox, Autocomplete, Button } from "@mui/material";
import axios from "axios";
import baseUrl from "../../../config/baseUrl";
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';

const icon = <CheckBoxOutlineBlankOutlinedIcon fontSize="small" />;
const checkedIcon = <CheckBoxOutlinedIcon fontSize="small" />;

function CompanyProfile() {
  const auth = sessionStorage.getItem("user");
  const [countryName, setCountryName] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);

  const [formState, setFormState] = useState({
    bname: '',
    trading_dba: '',
    blocation: '',
    busines_Code: '',
    busines_Country: '',
    company_website_target_live_date: '',
    fname: '',
    lname: '',
    main_contact_email: ''
  });

  const ReadData = async () => {
    try {
      let values = { 
        tab: 1
      };
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      let result = await axios.post(`${baseUrl}/defaultBusinesSettingData`, values, config);
      setFormState(result.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  const merchantData = async () => {
    try {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };

      let result = await axios.post(`${baseUrl}/allCountries`, {}, config);
      setCountryName(result.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      let values = {
        bname: formState.bname,
        trading_dba: formState.trading_dba,
        blocation: formState.blocation,
        busines_Code: formState.busines_Code,
        busines_Country: formState.busines_Country,
        company_website_target_live_date: formState.company_website_target_live_date,
        fname: formState.fname,
        lname: formState.lname,
        main_contact_email: formState.main_contact_email,
        payoutCountries: selectedCountries.map((currency) => currency.value),
      };

      const config = {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${auth}`,
        },
      };

      let result = await axios.post(`${baseUrl}/save_company_profile`, values, config);
      if (result.status === 200) {
        alert(result.data.message);
      } else {
        alert(result.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (formState.payoutCountries && countryName.length > 0) {
      const selected = formState.payoutCountries
        .split(',')
        .map(id =>
          countryName.find(country => country.value === parseInt(id))
        )
        .filter(Boolean);
      setSelectedCountries(selected);
    }
  }, [formState.payoutCountries, countryName]);

  useEffect(() => {
    ReadData();
    merchantData();
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Company Name"
          name="bname"
          value={formState.bname}
          variant="outlined"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Trading As / DBA"
          name="trading_dba"
          value={formState.trading_dba}
          variant="outlined"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Registered Address"
          name="blocation"
          value={formState.blocation}
          variant="outlined"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Company Number / Registration Number"
          name="busines_Code"
          value={formState.busines_Code}
          variant="outlined"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          select
          fullWidth
          label="Country of Incorporation"
          name="busines_Country"
          value={formState.busines_Country}
          variant="outlined"
          onChange={handleChange}
        >
          {countryName.map((country) => (
            <MenuItem key={country.value} value={country.value}>
              {country.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Incorporation Date"
          type="date"
          name="company_website_target_live_date"
          value={formState.company_website_target_live_date}
          variant="outlined"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          multiple
          id="checkboxes-tags-demo"
          options={countryName}
          disableCloseOnSelect
          getOptionLabel={(option) => option.label || ""}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.label}
            </li>
          )}
          fullWidth
          renderTags={(value) =>
            value.length > 0 ? `${value.length} value(s) selected` : ""
          }
          value={selectedCountries}
          onChange={(event, newValue) => setSelectedCountries(newValue)}
          renderInput={(params) => (
            <TextField {...params} label="Payout Countries" />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Main Contact Person First Name"
          name="fname"
          value={formState.fname}
          variant="outlined"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Main Contact Person Last Name"
          name="lname"
          value={formState.lname}
          variant="outlined"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Main Contact Person Email"
          name="main_contact_email"
          value={formState.main_contact_email}
          variant="outlined"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <Button
          onClick={handleSave}
          variant="contained"
          color="success"
          size="medium"
          sx={{
            float: "inline-end"
          }}
        >
          Save
      </Button>
      </Grid>
    </Grid>
  );
}

export default CompanyProfile;
